<div>
  <app-version-detail *ngFor="let feature of this.features" [clFeature]="feature"></app-version-detail>
</div>
